var map = {
	"./background-image-1.avif": 350,
	"./background-image-2.avif": 303,
	"./background-image-3.avif": 800,
	"./background-image-4.avif": 289,
	"./background-image-5.avif": 874,
	"./background-image-6.avif": 899,
	"./background-image-7.avif": 356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;